  // Extract the client name from the domain to make the job board client-specific
  // Note that on staging, extractedClientName will be of the format "staging-clientName" whereas on production it'll just be the client name
  export const extractedClientNameFromURL = (): string => {
    const URL = window.location.href;

    const strippedURLScheme = URL.split('//')[1]; // Removes https:// or http://
    let extractedClientName = strippedURLScheme.split('.')[0]; // Remove 2nd level domain onwards

    if (extractedClientName.toLowerCase().includes('localhost:3000')) {
        extractedClientName = 'criterion-psycruit-findyourjoy-v1';
    }

    return extractedClientName;
  }